import { BrandingThemeItem } from '@/types/brandingThemes';
import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import BrandingThemeCopyDeleteDialog from '../BrandingThemeCopyDeleteDialog';
import { SVButton } from '@/components/core';

type BrandingThemesManageMenuProps = {
  theme: BrandingThemeItem;
};

export default function BrandingThemesManageMenu({
  theme,
}: BrandingThemesManageMenuProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { uuid, isProgramDefault } = theme;

  return (
    <>
      <SVButton onClick={handleClick}>Manage</SVButton>
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              minWidth: 150,
            },
          },
        }}>
        <MenuItem
          onClick={() =>
            navigate(`${ROUTES.BRANDING_THEME_VIEW_PARAMS}/${uuid}`)
          }>
          View
        </MenuItem>
        <MenuItem
          onClick={() =>
            navigate(`${ROUTES.BRANDING_THEME_EDIT_PARAMS}/${uuid}`)
          }>
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpen(true);
            setIsDelete(false);
          }}>
          Copy
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpen(true);
            setIsDelete(true);
          }}
          disabled={isProgramDefault}>
          Delete
        </MenuItem>
      </Menu>
      <BrandingThemeCopyDeleteDialog
        uuid={uuid}
        name={theme.name}
        isDelete={isDelete}
        open={open}
        setOpen={setOpen}
        shouldNavigate={false}
      />
    </>
  );
}
